// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"6a32be24","332":"4485b459","565":"d721e9b7","763":"795deadc","787":"75ae4b52"}[chunkId] + ".chunk.js";
};